import { createInjectionKey } from '../../_utils';
export const formInjectionKey = createInjectionKey('n-form');
export const formItemInstsInjectionKey = createInjectionKey('n-form-item-insts');
